import { defineMessages } from "react-intl";
const localizedDatePickerFooterRangeMode = defineMessages({
  datePickerFooterRangeModeFromLabel: {
    id: "datePickerFooterRangeModeFromLabel",
    defaultMessage: "From"
  },
  datePickerFooterRangeModeToLabel: {
    id: "datePickerFooterRangeModeToLabel",
    defaultMessage: "To"
  }
});
export {
  localizedDatePickerFooterRangeMode
};
//# sourceMappingURL=DatePickerFooterRangeMode.localize.js.map
